<ion-content>
  <div class="share" *ngIf="share">
    <div class="header">
      <a (click)="close()"><i class="ti ti-arrow-left me-2"></i> Retour</a>
    </div>
    <div class="content">

      <h1>
        {{ share.source === 'enterprise' ? 'Message partagé' : 'Message reçu' }}
      </h1>

      <!-- Sent by or from -->
      <div class="type mt-5">
        <h5 class="fw-bold special-color">{{ share.source === 'enterprise' ? 'Envoyé à' : 'Reçu de' }}</h5>
        <p class="fw-bold">
          <!-- Sender or receiver is mutuelle or insured -->
          <img class="logo-icon mb-3" [src]="'assets/specific/' + logoFilename"
            *ngIf="(share.source === 'enterprise' && share.target === 'mutuelle') || (share.source === 'mutuelle' && share.target === 'enterprise')">
          <ng-container *ngIf="share.source === 'insured' || share.target === 'insured'">
            {{ share.insuredName }}
          </ng-container>
        </p>
      </div>
      <!-- Date of the share -->
      <div class="type mt-3">
        <h5 class="fw-bold special-color">
          {{ share.source === 'enterprise' ? 'Date de l\'envoi' : 'Date de réception' }}
        </h5>
        <p class="fw-bold">{{ share?.createdAtFormatted() }}</p>
      </div>
      <!-- Message -->
      <div class="mt-5">
        <h5 class="fw-bold special-color">Message</h5>
        <p *ngIf="share?.message" class="mt-3">
          {{ share.message }}
        </p>
      </div>
      <!-- Documents -->
      <div class="documents d-flex flex-column mt-5" *ngIf="share?.documents?.length > 0">
        <h5 class="fw-bold special-color">Documents</h5>
        <table class="table rounded mt-3">
          <thead>
            <tr>
              <th>Nom du fichier</th>
              <th>Taille</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let d of share?.documents">
              <td>{{ d.title }}</td>
              <td>{{ d.sizeFormatted() }}</td>
              <td>
                <div class="actions d-flex flex-row justify-content-end align-items-center gap-2">
                  <button class="button s icon dark" (click)="downloadDocuments([d])" type="button"
                    *ngIf="d.size > 0"><i class="ti ti-cloud-download"></i></button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- Infos -->
      <div class="info-message mt-3 mb-3" *ngIf="share?.target === 'mutuelle'">
        <i class="ti ti-info-hexagon"></i>
        <p class="fw-bold">Les documents non présents ici ont été envoyés par mail à la mutuelle.</p>
      </div>

      <!-- Global actions -->
      <!-- <div class="d-flex flex-row mt-3 gap-2">
        <button class="button m secondary expand" (click)="downloadDocuments(selection)"
          *ngIf="selection.length > 0">Télécharger la sélection<span class="chip ms-2" *ngIf="selection.length > 0">{{
            selection.length }}</span></button>
      </div>
      <button class="button m dark w-100 mt-2" (click)="downloadDocuments(share?.documents)"
        *ngIf="share?.documents?.length > 1">Télécharger tous les documents</button>
      <button class="button m primary w-100 mt-2" (click)="reply()"
        *ngIf="authService.user.value?.role !== 'readonly' && !share?.isSentByMe(authService.user.value)">Nouvel envoi à
        {{ share?.sourceFormatted(authService.user.value) }}</button> -->
    </div>
  </div>
</ion-content>